import { YOUTUBE_LINK } from '@constants';

export function isYouTubeVideo(url: string) {
  return YOUTUBE_LINK.test(url);
}
